import { isBefore, parse } from 'date-fns';
import { useMemo } from 'react';

import { useABTesting } from './abTesting';
import { Category } from '@/api/games';
import { Locale } from '@/helpers/languages';
import { useCommonStore } from '@/store';

export const MAP_LEGENDS_CATEGORY_BY_LOCALE: Record<Locale, Category> = {
  [Locale.ENGLISH]: Category.LEGENDS_EN,
  [Locale.ENGLISH_CANADA]: Category.LEGENDS_CA,
  [Locale.ENGLISH_AUSTRALIA]: Category.LEGENDS_AU,
  [Locale.ENGLISH_IRELAND]: Category.LEGENDS_EN,
  [Locale.ENGLISH_NEW_ZEALAND]: Category.LEGENDS_NZ,
  [Locale.GERMAN]: Category.LEGENDS_DE,
  [Locale.FRENCH_CANADA]: Category.LEGENDS_CA,
  [Locale.FRENCH_SWITZERLAND]: Category.LEGENDS_CH,
  [Locale.NORWEGIAN]: Category.LEGENDS_NO,
  [Locale.ESTONIA]: Category.LEGENDS_EN,
  [Locale.FINLAND]: Category.LEGENDS_EN,
};

enum ExpLegendsLobbyEnum {
  A = 'a_lobby_default_no_legends',
  B = 'b_lobby_with_legends',
}

const START_DATE = parse(
  '2025-04-14 00:00:00 UTC',
  "yyyy-MM-dd HH:mm:ss 'UTC'",
  new Date()
);

export const useABLegendsLobby = () => {
  const user = useCommonStore.use.user();
  const isAuthenticated = useCommonStore.use.isAuthenticated();

  const turnOffTest = useMemo(() => {
    if (!isAuthenticated || !user || typeof user.createdAt !== 'string') {
      return true;
    }
    return isBefore(new Date(user.createdAt), START_DATE);
  }, [isAuthenticated, user]);

  const isLegendsVisible =
    useABTesting('exp_legends_lobby_lu', {
      defaultVersion: ExpLegendsLobbyEnum.A,
      versions: [
        { name: ExpLegendsLobbyEnum.A, probability: 50 },
        { name: ExpLegendsLobbyEnum.B, probability: 50 },
      ],
      turnOffTest,
    }) === ExpLegendsLobbyEnum.B;

  return isLegendsVisible;
};
